<template>
    <figure class="quote">
        <img
            v-if="image"
            class="quote__image"
            :src="image.url"
            :alt="`Image of ${quote}`"
        >
        <blockquote class="quote__content">
            <slot>{{ quote }}</slot>
        </blockquote>

        <figcaption
            v-if="author && (internalLink || externalLink)"
            class="quote__link"
        >
            {{ author }},
            <NuxtLink
                v-if="internalLink"
                :to="`/${internalLink}`"
            >
                {{ linkText }}
            </NuxtLink>
            <a
                v-else-if="externalLink"
                :href="externalLink"
                target="_blank"
            >
                {{ linkText }}
            </a>
        </figcaption>

        <figcaption
            v-else-if="author || $slots.author"
            class="quote__author"
        >
            <slot name="author">{{ author }}</slot>
        </figcaption>
    </figure>
</template>

<script setup>
defineProps({
    quote: {
        type: String,
        required: true,
        default: null,
    },
    author: {
        type: String,
        default: null,
    },
    image: {
        type: Object,
        default: null,
    },
    internalLink: {
        type: String,
        default: null,
    },
    externalLink: {
        type: String,
        default: null,
    },
    linkText: {
        type: String,
        default: 'Read their story',
    }
});
</script>

<style lang="less" src="./BaseQuote.less" />
